// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VanillaCookieconsent from "vanilla-cookieconsent";
import * as CookieConsentConstants$PorterinCookieConsentManager from "../constants/CookieConsentConstants.mjs";
import * as CookieConsentConfigFactory$PorterinCookieConsentManager from "../factory/CookieConsentConfigFactory.mjs";

function init(categories, translations, onConsentChangeCallback) {
  return VanillaCookieconsent.run(CookieConsentConfigFactory$PorterinCookieConsentManager.makePluginConfig(categories, translations, onConsentChangeCallback));
}

function resetCookieConsentManager(param) {
  VanillaCookieconsent.reset(true);
  return VanillaCookieconsent.run(VanillaCookieconsent.getConfig());
}

function setLanguage(language, reloadPage) {
  return VanillaCookieconsent.setLanguage(language, reloadPage);
}

function getUserPreferences(param) {
  return VanillaCookieconsent.getUserPreferences();
}

function acceptAllCookies(param) {
  VanillaCookieconsent.acceptCategory(CookieConsentConstants$PorterinCookieConsentManager.all, [], undefined);
  VanillaCookieconsent.hide();
}

export {
  init ,
  resetCookieConsentManager ,
  setLanguage ,
  getUserPreferences ,
  acceptAllCookies ,
}
/* vanilla-cookieconsent Not a pure module */
